import PropTypes from "prop-types"
import { isFunction, map } from "lodash"
import { TableBody, TableCell, TableRow } from "@mui/material"
import { COLUMN_SHAPE } from "../shapes"
import classNames from "classnames"

function emptyFormatter(value) {
  return value === "" ? "-" : value
}

export default function TableDropdownBody({ columns, items, onItemClick, selectedItemId, formatter: customFormatter }) {
  return (<TableBody>
    {map(items, item => <TableRow
      key={`${item.id}-row`}
      className={classNames("component_table-dropdown-row", { selected: selectedItemId === item.id })}
      onClick={() => onItemClick(item)}
    >
      {map(columns, ({ id, align, getter, formatter }) => {
        let valueFormatter = value => value
        if (customFormatter && id === "value") {
          valueFormatter = customFormatter
        } else if (isFunction(formatter)) {
          valueFormatter = formatter
        }
        const value = valueFormatter(getter(item, id))
        return <TableCell
          key={`${id}-${item.id}`}
          align={align ?? "right"}
        >
          {emptyFormatter(value)}
        </TableCell>
      })}
    </TableRow>)}
  </TableBody>)
}

TableDropdownBody.propTypes = {
  columns: PropTypes.arrayOf(COLUMN_SHAPE).isRequired,
  items: PropTypes.array.isRequired,
  onItemClick: PropTypes.func.isRequired,
  selectedItemId: PropTypes.string.isRequired,
  formatter: PropTypes.func,
}
